import React from 'react';

export default function CalendarDayHeading({day,count,today,itemLabel='event'}) {
  const label=count===null?'…':`${count} ${itemLabel}${count===1?'':'s'}`;
  return <h4 className="calendar-day-heading" data-today={today||undefined}><span className="calendar-day-heading__date"><span>{day.toFormat('ccc')}</span> <strong>{day.toFormat('d LLL')}</strong></span><span className="calendar-day-heading__meta">{today&&<small>Today</small>}<span className="calendar-day-heading__count" aria-label={count===null?`Loading ${itemLabel} count`:label}>{label}</span></span></h4>;
}
